import { useState } from 'react';
import ModalBtn from '../../molecules/modalButton/view';
import Table from '../../molecules/tablas/view';
import { BsViewList } from 'react-icons/bs';
import './style.css';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { getBuyById } from '../../../usecases/buys-usecase';
import { IoReload } from 'react-icons/io5';
import { BiCheckCircle } from 'react-icons/bi';
import ShowThird from '../../organisms/showThird/view';

const ListIemsCompra = ({ data, profile }) => {
  const [details, setDetails] = useState(null);

  const formatCurrency = (value) =>
    new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      maximumFractionDigits: 0,
    }).format(value || 0);

  function handleOpen() {
    setDetails(null);
    getBuyById(profile.uid, profile.cid, data.bill_id)
      .then((res) => {
        setDetails(res);
      })
      .catch(() => {
        dispatchCustomEvent('popup', {
          message: 'Error al cargar el detalle',
          type: 'error',
        });
      });
  }

  const calculateSubtotal = (items = []) =>
    items.reduce(
      (acc, item) => acc + parseFloat(item.value) * parseFloat(item.amount),
      0
    );

  const calculateTaxes = (items = []) =>
    items.reduce(
      (acc, item) =>
        acc +
        parseFloat(item.value) *
          parseFloat(item.amount) *
          (parseFloat(item.tax_buy_value) / 100),
      0
    );

  const calculateTotal = (items = []) =>
    calculateSubtotal(items) + calculateTaxes(items);

  return (
    <ModalBtn
      id={'compra-' + data.bill_id}
      title={<BsViewList />}
      onClick={handleOpen}
      width="85vw"
      type="action"
    >
      {details ? (
        <div className="list-compras-box" style={{ overflow: 'hidden' }}>
          <div className="comprobante-body-grid">
            <div className="comprobante-general-info">
              <div className="info-field-group">
                <span className="info-label">Proveedor</span>
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '10px' }}
                >
                  <ShowThird
                    id={'buy-detail'}
                    data={{ third_id: details.third_id }}
                  />
                </div>
              </div>
              <div className="info-subgrid">
                <div className="info-field-group">
                  <span className="info-label">Tipo Transacción</span>
                  <span className="info-value">Compra de Inventario</span>
                </div>
                <div className="info-field-group">
                  <span className="info-label">Documento</span>
                  <span className="info-value">
                    #{details.bill_id} / {details.documento_compra}
                  </span>
                </div>
              </div>
              <div className="info-subgrid">
                <div className="info-field-group">
                  <span className="info-label">Fecha Registro</span>
                  <span className="info-value">
                    {new Date(details.buy_date).toLocaleDateString()}
                  </span>
                </div>
                {details.vencimiento && (
                  <div className="info-field-group">
                    <span className="info-label">Vencimiento</span>
                    <span className="info-value">
                      {new Date(details.vencimiento).toLocaleDateString()}
                    </span>
                  </div>
                )}
              </div>
            </div>

            <div className="balance-card-modern balanced">
              <div className="card-header-status">
                <span className="status-badge">
                  <BiCheckCircle /> ESTADO: REGISTRADO
                </span>
                <span className="resumen-label">RESUMEN DE COMPRA</span>
              </div>
              <div
                className="card-totals-grid"
                style={{ gridTemplateColumns: '1fr 1fr' }}
              >
                <div
                  className="total-col"
                  style={{
                    borderRight: '1px solid #d1f2eb',
                    paddingRight: '15px',
                  }}
                >
                  <span className="total-label-modern">Subtotal</span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.4rem' }}
                  >
                    {formatCurrency(calculateSubtotal(details.data))}
                  </span>
                </div>
                <div className="total-col" style={{ paddingLeft: '15px' }}>
                  <span className="total-label-modern">Total con IVA</span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.4rem' }}
                  >
                    {formatCurrency(calculateTotal(details.data))}
                  </span>
                </div>
              </div>
              <div
                className="card-totals-grid"
                style={{
                  gridTemplateColumns: '1fr 1fr',
                  borderTop: '1px solid #d1f2eb',
                  marginTop: '10px',
                  paddingTop: '10px',
                }}
              >
                <div
                  className="total-col"
                  style={{
                    borderRight: '1px solid #d1f2eb',
                    paddingRight: '15px',
                  }}
                >
                  <span
                    className="total-label-modern"
                    style={{ color: '#e74c3c' }}
                  >
                    Retenciones
                  </span>
                  <span
                    className="total-amount-modern"
                    style={{ fontSize: '1.2rem', color: '#e74c3c' }}
                  >
                    -{' '}
                    {formatCurrency(
                      details.data.reduce(
                        (acc, item) => acc + parseFloat(item.retention || 0),
                        0
                      )
                    )}
                  </span>
                </div>
                <div className="total-col" style={{ paddingLeft: '15px' }}>
                  <span
                    className="total-label-modern"
                    style={{ fontWeight: '800' }}
                  >
                    TOTAL A PAGAR
                  </span>
                  <span
                    className="total-amount-modern"
                    style={{
                      fontSize: '1.4rem',
                      color: '#27ae60',
                      fontWeight: '800',
                    }}
                  >
                    {formatCurrency(
                      calculateTotal(details.data) -
                        details.data.reduce(
                          (acc, item) => acc + parseFloat(item.retention || 0),
                          0
                        )
                    )}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            className="comprobante-lines-section"
            style={{ maxHeight: '30vh', overflowY: 'auto' }}
          >
            <div className="lines-header-row">
              <h3 className="lines-title-modern">DETALLE DE PRODUCTOS</h3>
            </div>
            <Table
              id={'items-' + data.bill_id}
              data={(details.data || []).map((item) => ({
                producto: item.product
                  ? `${item.product.sku} - ${item.product.name}`
                  : 'N/A',
                amount: item.amount,
                tax_buy_value: item.tax_buy_value,
                value: item.value,
                total:
                  parseFloat(item.value) *
                  parseFloat(item.amount) *
                  (1 + parseFloat(item.tax_buy_value) / 100),
              }))}
              maxHeight="30vh"
              headersList={[
                'PRODUCTO',
                'CANT.',
                'IVA %',
                'BASE UNIT.',
                'TOTAL + IVA',
              ]}
              excludeList={['id']}
              formats={{
                value: { type: 'money' },
                total: { type: 'money' },
              }}
            />
          </div>

          <div
            className="comprobante-lines-section"
            style={{ marginTop: '10px' }}
          >
            <div className="lines-header-row">
              <h3 className="lines-title-modern">DISTRIBUCIÓN DE PAGOS</h3>
            </div>
            <Table
              id={'payments-' + data.bill_id}
              headersList={['MÉTODO DE PAGO', 'VALOR PAGADO']}
              excludeList={['id', 'bill_id', 'paymethod_id']}
              data={(details.payment || []).map((p) => ({
                method:
                  (details.paymethod || []).find((m) => m.id === p.paymethod_id)
                    ?.method || 'Otro',
                value: p.value,
              }))}
              maxHeight="15vh"
              formats={{
                value: { type: 'money' },
              }}
            />
          </div>
        </div>
      ) : (
        <div
          className="loading-container"
          style={{ padding: '80px', textAlign: 'center', opacity: 0.6 }}
        >
          <IoReload
            className="spin"
            style={{ fontSize: '2.5rem', marginBottom: '15px' }}
          />
          <p>Cargando información detallada...</p>
        </div>
      )}
    </ModalBtn>
  );
};

export default ListIemsCompra;
